<!-- <button mat-icon-button class="close-button" [mat-dialog-close]="true">
    <mat-icon class="close-icon">close</mat-icon>
</button> -->
<div class="container1">
<mat-toolbar>
    <mat-toolbar-row class="justify-content-between">
      <div class="row mr-2 ml-auto">
        <ul>
          <li>
            <button mat-button class="user mt-2 mb-3 d-flex align-items-center">
              <img [src]="createImgPath(this.logoFile)" class="logo mr-1 p-2" />
            </button>
          </li>
        </ul>
      </div>
      <button mat-button class="user mt-1 mb-4 d-flex align-items-right">
        <img src="../../../assets/images/final automated.png" class="user-image mr-1 p-2" />
      </button>
    </mat-toolbar-row>
  </mat-toolbar>
<div class="container">
   
        <h1>Payment Accepted</h1>
        <h2>Thank you for your payment.You may now close this browser tab.</h2>
   
</div>
<app-footer></app-footer>
</div>